/** @flow */

import type { EmailControlsState } from "./types";

export const initialState: EmailControlsState = {
  requestsInProgress: 0,
  settings: null,
  modals: {
    addNewEmailDomain: {
      visible: false,
    },
    editEmailContentSettings: {
      visible: false,
      data: null,
    },
  },
};

export default initialState;
